import angular from 'angular'

import trainCtrl from './train.controller'
import trainRoutes from './train.routes'
import trainRun from './train.run'

const name = 'routingConsultTrain'

angular.module(name, [])
  .controller('trainCtrl', trainCtrl)
  .config(trainRoutes)
  .run(trainRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/train/train.module.js